import { h } from '@/lib/dom';
import { Navbar } from '@/components/Navbar';
import type { UserPublic } from '@/api/types';

type LayoutChild = Node | string | number | false | null | undefined;

export interface PageLayoutProps {
  user: UserPublic;
  active?: string;
  children: LayoutChild | LayoutChild[];
  extraTopbar?: Node | null;
}

export function pageLayout(props: PageLayoutProps): HTMLElement {
  return h('div', { class: 'app-shell' }, [
    Navbar({ user: props.user, active: props.active }),
    props.extraTopbar ?? null,
    h('main', { id: 'main-content', class: 'app-main', role: 'main' },
      Array.isArray(props.children) ? props.children : props.children),
  ]);
}
